export default {"src":"/_next/static/media/average.1e3f3e8c.svg","height":51,"width":60};